export default {
      id: "html-usage",
      viewBox: "-41 0 512 512",
      url: __webpack_public_path__ + "../../sprite.svg#html-usage",
      toString: function () {
        return this.url;
      }
    }